import { CurrencyId_Schema } from "@/services/currencies/currenciesSchema";
import { DateTimeIso8601_Schema, WholeNumber_Schema } from "@/utilities/schema";
import { z } from "zod";

export const Price_Schema = z.object({
  price: WholeNumber_Schema,
  currencyId: CurrencyId_Schema,
  type: z.string(), // Maybe some enum?
  validFrom: DateTimeIso8601_Schema.nullable(),
  validTo: DateTimeIso8601_Schema.nullable(),
});

export const PriceElastic_Schema = z.object({
  currencyId: CurrencyId_Schema,
  price: z.number().positive(),
  type: z.string(),
});
